import React from 'react';
import WhatsAppBookingLink from './WhatsAppBookingLink';

const WhatsAppFloatingAction: React.FC = () => {
  return (
    <WhatsAppBookingLink className="sw-whatsapp-fab" placement="home_floating">
      WhatsApp
    </WhatsAppBookingLink>
  );
};

export default WhatsAppFloatingAction;
